import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, lockedPath } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { AuthShell, Field, PasswordField, FormError, SubmitButton, AuthLink } from "@/components/auth/AuthShell";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name || "there"}`);
      if (!user.access?.active) { navigate(lockedPath(user)); return; }
      navigate(location.state?.from || (user.role === "admin" ? "/admin" : "/"));
    } catch (err) {
      setError(errorMessage(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Sign in" subtitle="Pick up your progress and bookmarks."
      footer={<>Clinician without an account? <AuthLink to="/apply" testId="login-apply-link">Apply for access</AuthLink></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field id="email" label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" placeholder="you@example.com" testId="login-email-input" />
        <PasswordField id="password" label="Password" value={password} onChange={setPassword} autoComplete="current-password" testId="login-password-input" />
        <div className="text-right -mt-2"><AuthLink to="/forgot-password" testId="forgot-password-link">Forgot password?</AuthLink></div>
        <FormError message={error} />
        <SubmitButton loading={loading} testId="login-submit-button">Sign in</SubmitButton>
      </form>
    </AuthShell>
  );
}
